import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const EmojiHappyIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0361 4C16.4544 4 20.0361 7.58172 20.0361 12C20.0361 16.4183 16.4544 20 12.0361 20C7.61786 20 4.03613 16.4183 4.03613 12C4.03613 7.58172 7.61786 4 12.0361 4ZM22.0361 12C22.0361 6.47715 17.559 2 12.0361 2C6.51328 2 2.03613 6.47715 2.03613 12C2.03613 17.5228 6.51328 22 12.0361 22C17.559 22 22.0361 17.5228 22.0361 12ZM16.0361 10C16.0361 9.44772 15.5884 9 15.0361 9H15.0261C14.4738 9 14.0261 9.44772 14.0261 10C14.0261 10.5523 14.4738 11 15.0261 11H15.0361C15.5884 11 16.0361 10.5523 16.0361 10ZM10.0361 10C10.0361 9.44772 9.58842 9 9.03613 9H9.02613C8.47385 9 8.02613 9.44772 8.02613 10C8.02613 10.5523 8.47385 11 9.02613 11H9.03613C9.58842 11 10.0361 10.5523 10.0361 10ZM15.5717 14.1213C15.1811 13.7308 14.548 13.7308 14.1575 14.1213C12.9859 15.2929 11.0864 15.2929 9.91481 14.1213C9.52429 13.7308 8.89112 13.7308 8.5006 14.1213C8.11007 14.5118 8.11007 15.145 8.5006 15.5355C10.4532 17.4882 13.619 17.4882 15.5717 15.5355C15.9622 15.145 15.9622 14.5118 15.5717 14.1213Z"
            />
        </SvgIcon>
    );
};

export default EmojiHappyIcon;
